import type { ReactNode } from "react";
import type { EmissionRecordView } from "../../../apiClient/generated";
import type { FieldDefinition } from "../formDefinition";

export interface EventFormFieldProps {
    fieldDefinition: FieldDefinition;
    emissionRecord: EmissionRecordView;
    suggestedValue?: unknown;
}

const getErrorMessages = (error: unknown): string[] => {
    if (!error || typeof error !== "object") return [];
    const e = error as { message?: unknown; types?: Record<string, unknown> };
    if (e.types) {
        return Object.values(e.types).flatMap((v) =>
            Array.isArray(v) ? v.map(String) : [String(v)],
        );
    }
    if (e.message != null) return [String(e.message)];
    return [];
};

export const FormFieldBase = ({
    label,
    children,
    error,
}: {
    label?: string;
    children: ReactNode;
    error?: unknown;
}) => {
    const messages = getErrorMessages(error);
    return (
        <div className="text-sm">
            {label && <p className="mb-0.5 text-neutral-500">{label}</p>}
            {children}
            {messages.map((msg, i) => (
                <p key={i} className="text-red-500 mt-0.5">
                    {msg}
                </p>
            ))}
        </div>
    );
};

export const SuggestionBox = ({
    suggestedValueLabel,
    onApply,
}: {
    suggestedValueLabel: string;
    onApply: () => void;
}) => (
    <div className="mt-1 flex items-center justify-between gap-2 rounded border border-neutral-200 bg-neutral-50 px-2 py-1 text-sm">
        <span className="flex items-center gap-1.5 text-neutral-500">
            Suggested value:{" "}
            <span className="text-neutral-700">{suggestedValueLabel}</span>
        </span>
        <button
            type="button"
            className="text-ae-blue-500 hover:text-ae-blue-600 transition-colors"
            onClick={onApply}
        >
            Apply
        </button>
    </div>
);
